export default "__VITE_ASSET__Dsp00mD0__"